import React from 'react';
import './LinksAndContact.css';

import x from '../../asset/x.svg';
import backToMenu from "../../asset/back_to_menu.svg";
import inProgress from "../../asset/workInProgress.svg";

function Links({showLinksAndContactModal, setShowLinksAndContactModal, handleBackToMenuClick, resetIcons}) {
    return (
        <div>
            {showLinksAndContactModal && (
                <div>
                    <div className="Links-contact-modal-shadow">
                    </div>

                    <div className="Links-contact-modal">
                        <img
                            src={x}
                            alt={"x"}
                            onClick={
                                () => {
                                    setShowLinksAndContactModal(false);
                                    resetIcons();
                                }
                            }
                            className="Links-contact-modal-upper-x"
                            style={{
                                width: "auto",
                                height: "40px",
                                float: "right",
                                marginTop: "5px",
                                marginRight: "3%"
                            }}
                        />
                        <div
                            className="links-contact-modal-back-container"
                        >
                            <img
                                src={inProgress}
                                alt={"work-in-progress"}
                                style={{
                                    width: "auto",
                                    height: "40px"
                                }}
                            />
                            <img
                                src={backToMenu}
                                alt={"back-to-menu"}
                                className="links-contact-modal-back-to-menu"
                                onClick={handleBackToMenuClick}
                                style={{
                                    width: "auto",
                                    height: "40px"
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Links;